
import * as React from "react";
import { cn } from "@/lib/utils";

interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  size?: "default" | "compact";
}

const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ className, icon, title, description, action, size = "default", ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col items-center justify-center text-center",
          size === "default" ? "p-10 space-y-4" : "p-6 space-y-2",
          className
        )}
        {...props}
      >
        {icon && (
          <div className={cn(
            "rounded-full bg-muted flex items-center justify-center",
            size === "default" ? "w-16 h-16" : "w-10 h-10"
          )}>
            {icon}
          </div>
        )}
        {title && (
          <h3 className={cn(
            "font-semibold text-foreground",
            size === "default" ? "text-lg" : "text-base"
          )}>
            {title}
          </h3>
        )}
        {description && (
          <p className={cn(
            "text-muted-foreground max-w-sm mx-auto",
            size === "default" ? "text-sm" : "text-xs"
          )}>
            {description}
          </p>
        )}
        {action && <div className="pt-2">{action}</div>}
      </div>
    );
  }
);

EmptyState.displayName = "EmptyState";

export { EmptyState };
